import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function BorrarCuenta() {
  const [email, setEmail] = useState('')
  const [motivo, setMotivo] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [error, setError] = useState('')

  const enviar = async () => {
    if (!email.trim()) { setError('Ingresá tu email'); return }
    setEnviando(true)
    setError('')
    const { error: err } = await supabase.from('solicitudes_borrado').insert({
      email: email.trim(),
      motivo: motivo.trim() || null
    })
    if (err) { setError('No se pudo enviar la solicitud. Intentá de nuevo.'); setEnviando(false); return }
    setEnviado(true)
    setEnviando(false)
  }

  return (
    <div className="perfil-page" style={{ padding: '24px 20px', maxWidth: 480, margin: '0 auto' }}>
      <button className="btn-secundario" onClick={() => { window.location.href = '/' }}>
        ← Volver
      </button>

      <div className="page-header" style={{ marginTop: 20 }}>
        <h1 className="page-titulo">Eliminar cuenta y datos</h1>
        <p className="page-subtitulo">Juco</p>
      </div>

      {enviado ? (
        <div className="empty-state">
          <div className="empty-icon">✓</div>
          <p>Recibimos tu solicitud. La vamos a procesar en los próximos días hábiles y te confirmamos por email cuando tu cuenta y tus datos hayan sido eliminados.</p>
        </div>
      ) : (
        <div className="progreso-form">
          <p style={{ fontSize: 14, color: 'var(--gris)', marginBottom: 16 }}>
            Si ya no tenés acceso a la app o preferís pedirlo desde acá, completá tu email y vamos a eliminar tu cuenta y todos tus datos asociados.
          </p>
          <label className="form-label">Email de tu cuenta</label>
          <input className="form-input" type="email" placeholder="tu@email.com"
            value={email} onChange={e => setEmail(e.target.value)} />

          <label className="form-label">Motivo — opcional</label>
          <textarea className="form-input" rows={3} placeholder="Contanos por qué te vas, nos ayuda a mejorar"
            value={motivo} onChange={e => setMotivo(e.target.value)} />

          {error && <p className="auth-error">{error}</p>}

          <button className="btn-primario" style={{ width: '100%', marginTop: 12 }} onClick={enviar} disabled={enviando}>
            {enviando ? 'Enviando...' : 'Solicitar eliminación'}
          </button>
        </div>
      )}
    </div>
  )
}
